import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_header_form = _resolveComponent("header-form");
    const _component_el_col = _resolveComponent("el-col");
    const _component_FRAPL01 = _resolveComponent("FRAPL01");
    const _component_table_form = _resolveComponent("table-form");
    const _component_scheme_form = _resolveComponent("scheme-form");
    const _component_el_row = _resolveComponent("el-row");
    return (_openBlock(), _createBlock(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (_ctx.showByRoles(item))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createCommentVNode(" Special Condition when FR.APL.01 "),
                            (_ctx.formCode === 'FR.APL.01' &&
                                item.description &&
                                (item.description.toLowerCase().includes('bagian 2') ||
                                    item.description.toLowerCase().includes('bagian 2')))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_el_col, {
                                        lg: _ctx.widthForm(item)
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_header_form, _mergeProps(item, { preview: "" }), null, 16 /* FULL_PROPS */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["lg"]),
                                    _createVNode(_component_FRAPL01, {
                                        disabled: _ctx.disabledField(item)
                                    }, null, 8 /* PROPS */, ["disabled"])
                                ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createBlock(_component_el_col, {
                                    key: 1,
                                    lg: _ctx.widthForm(item)
                                }, {
                                    default: _withCtx(() => {
                                        var _a;
                                        return [
                                            (item.fieldType.name === _ctx.FieldType.Table)
                                                ? (_openBlock(), _createBlock(_component_table_form, {
                                                    key: 0,
                                                    "table-fields": item.tableFields,
                                                    disabled: _ctx.disabledField(item),
                                                    order: index
                                                }, null, 8 /* PROPS */, ["table-fields", "disabled", "order"]))
                                                : (item.fieldType.name === _ctx.FieldType.Scheme)
                                                    ? (_openBlock(), _createBlock(_component_scheme_form, _mergeProps({ key: 1 }, item, {
                                                        formRef: _ctx.formRef,
                                                        preview: _ctx.preview,
                                                        isAssessment: _ctx.isAssessment,
                                                        disabled: _ctx.disabledField(item)
                                                    }), null, 16 /* FULL_PROPS */, ["formRef", "preview", "isAssessment", "disabled"]))
                                                    : (_openBlock(), _createBlock(_resolveDynamicComponent(`${(_a = item.fieldType.name) === null || _a === void 0 ? void 0 : _a.replace(/ /g, '')}Form`), _mergeProps({ key: 2 }, Object.assign(Object.assign({}, item), (item.isMandatory && _ctx.setRules(index))), {
                                                        required: item.isMandatory,
                                                        modelValue: item.value,
                                                        "onUpdate:modelValue": ($event) => ((item.value) = $event),
                                                        preview: _ctx.preview,
                                                        disabled: _ctx.disabledField(item),
                                                        "statement-fields": item.statementFields,
                                                        relevantEvidenceFields: item.relevantEvidenceFields,
                                                        isAssessment: _ctx.isAssessment,
                                                        order: index
                                                    }), null, 16 /* FULL_PROPS */, ["required", "modelValue", "onUpdate:modelValue", "preview", "disabled", "statement-fields", "relevantEvidenceFields", "isAssessment", "order"]))
                                        ];
                                    }),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["lg"]))
                        ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */));
            }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
    }));
}
